export const preCaseTitle = '仿真场景：';
export const cardStatusText = {
    1: 'AI正在生成中，请稍后',
    2: 'AI已生成完毕，请点击卡片进入',
    0: '生成失败，请点击下方卡片重试'
};
export const factorMap = {
    when: 1,
    where: 2,
    who: 3,
    what: 4,
    why: 5
};
export const factorMapStr = {
    1: '时间',
    2: '地点',
    3: '人物',
    4: '事件',
    5: '原因'
};
export const factorMapEnStr = {
    1: 'TIME',
    2: 'LOCATION',
    3: 'PEOPLE',
    4: 'EVENT',
    5: 'CAUSE'
};
export const questionTypeMap = {
    single_choice_with_input: 'single_choice_with_input',
    multiple_choice_with_input: 'multiple_choice_with_input',
    single_choice: 'single_choice',
    multiple_choice: 'multiple_choice',
    short_answer: 'short_answer'
};
//卡片
export const stageMap = {
    answering: 'answering', //可以点击卡片
    completed: 'completed', //复盘报告完成
    failed: 'failed', //生成失败
    diagnosis: 'diagnosis', //复盘报告生成中
    event_result_generate: 'event_result_generate' //事件结果生成中
};

//页面的状态
export const pageProgressMap = {
    not_found: 'not_found', //会话不存在
    not_started: 'not_started', //未开始
    event_entered: 'event_entered', //已进入事件
    task_in_progress: 'task_in_progress', //答题进行中
    event_result_generating: 'event_result_generating', //事件结果生成中
    event_result_ready: 'event_result_ready', //事件结果已生成
    report_generating: 'report_generating', //复盘报告生成中
    report_ready: 'report_ready', //复盘报告已生成
    failed: 'failed' //生成失败
};
//顺序的 页面状态
export const orderProgress = [
    pageProgressMap.not_started,
    pageProgressMap.event_entered,
    pageProgressMap.task_in_progress,
    pageProgressMap.event_result_generating,
    pageProgressMap.event_result_ready,
    pageProgressMap.report_generating,
    pageProgressMap.report_ready
];
export const getPageProgressIndex = (progress) => {
    return orderProgress.indexOf(progress);
};
export let pathMap = {
    background: 'background',
    factor: 'factor',
    'role-introduce': 'role-introduce',
    event: 'event',
    'event-result': 'event-result',
    'review-report': 'review-report'
};
// 页面状态到路径的映射
export const progressToPathMap = {
    not_started: pathMap['background'],
    event_entered: pathMap['background'],
    task_in_progress: pathMap['event'],
    event_result_generating: pathMap['event-result'],
    event_result_ready: pathMap['event-result'],
    report_generating: pathMap['review-report'],
    report_ready: pathMap['review-report']
};
export const feedBackTypeMap = {
    instantBack: 0, //即时反馈
    instantBackAndCorrect: 1, //即时反馈并正确
    notBack: 2 //不反馈
};
export const caseCodeMap = {
    noAuth: '3013',
    noLogin: '3012'
};
